import { configureStore } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux';
import dffReducer from '../dff/dff-slice';
import pdfReducer from '../pdf-tool-manage/pdf-slice';
import userReducer from '../user/user-slice';

export const store = configureStore({
  reducer: {
    dff: dffReducer,
    pdf: pdfReducer,
    user: userReducer,
  },
  devTools: process.env.NODE_ENV !== 'production',
})

export type AppDispatch = typeof store.dispatch
export const useAppDispatch = () => useDispatch<AppDispatch>()
